import { getUserDetails } from "../../../app/api/getUserDetails";
import { BaseAction } from "../../../core/actions/BaseAction";
import { getRecoilStateValue, updateRecoilState, useRecState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IFmlmFavouriteLocationAtom } from "../../../Orchestrator/Recoils/LocationAtom";
import { IUserResponse, IApiResponse } from "../../../Orchestrator/Types/Index";


class GetUserDetailsAction extends BaseAction<IUserResponse, void> {
    // Coalesce concurrent execute() calls — multiple init paths (Topbar effect,
    // PassengerDetailsInitStep, internal call from GetPassengerDetailsAction)
    // all fire on checkout mount and would otherwise each hit /me.
    protected override deduplicate = true;

    // BaseAction._runWithCatch() clears this._result at the start of every
    // run(), so we keep our own session-scoped cache that survives between
    // execute() calls. invalidate() drops it on logout / profile mutation.
    private _cachedUser: IUserResponse | null = null;

    invalidate(): void {
        this._cachedUser = null;
    }

    override async run(): Promise<IUserResponse | null> {
        let userResponses: IUserResponse | null = null;
        try {
            if (this._cachedUser != null) {
                // Replay the cached value — userDataAtom is the source of truth
                // for downstream consumers; mutations of the user (login, save
                // profile) must call getUserDetailsAction.invalidate() to
                // force a re-fetch on the next execute(). Assign to
                // userResponses (not return) — the finally{ return ... }
                // below would otherwise overwrite an early return.
                userResponses = this._cachedUser;
                return userResponses;
            }
            const isAnonymous: boolean = getRecoilStateValue("isAnonymousStateAtom") as boolean;
            if (isAnonymous && isAnonymous === true) {
                return null;
            }
            const response: IApiResponse<IUserResponse> = await getUserDetails();

            if (response.status === "ok" && response.answer) {
                const userResponse = response.answer;
                if (userResponse) {
                    userResponses = userResponse;
                    this._cachedUser = userResponse;
                    updateRecoilState("userDataAtom", userResponse);

                    let firstAndLastMile = userResponse?.railPreferences?.firstAndLastMile;
                    if (firstAndLastMile) {
                        updateRecoilState<IFmlmFavouriteLocationAtom>("fmlmFavouriteLocationAtom", {
                            "firstMile": firstAndLastMile?.firstMile,
                            "lastMile": firstAndLastMile?.lastMile
                        })
                    }
                } else {
                    console.warn("No userdetail available.");
                }
            } else {
                console.warn("Failed to fetch userdetail.");
            }
            //}
        } catch (error: any) {
            console.error("Error fetching userdetail:", error);
        }
        finally {
            return userResponses;
        }
    }
}

export const getUserDetailsAction = new GetUserDetailsAction()


